/* Product image arrow-cursor navigation
 *
 * Adds two transparent overlay regions to the main product gallery (the
 * `.product__media-list.swiper` element on the PDP). Left half of the image
 * acts as a "previous" hotspot, right half as "next". Cursor changes to a
 * left- or right-pointing arrow on hover so customers see the affordance.
 *
 * The gallery uses Swiper, initialised in `assets/global.js > sliderInit()`.
 * The Swiper instance is attached to the element as `.swiper`, which we use
 * to call slidePrev()/slideNext() on click.
 *
 * Disabled on touch screens — touch users get native swipe.
 */
(function () {
  'use strict'

  function isTouch() {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      window.matchMedia('(hover: none)').matches
    )
  }

  function attachToSlider(sliderEl) {
    if (!sliderEl || sliderEl.dataset.arrowNavBound === '1') return
    sliderEl.dataset.arrowNavBound = '1'

    // Make absolutely sure the slider container can host absolutely-positioned
    // overlays. CSS handles this too but be defensive.
    if (getComputedStyle(sliderEl).position === 'static') {
      sliderEl.style.position = 'relative'
    }

    const prev = document.createElement('button')
    prev.type = 'button'
    prev.className = 'product__media-nav-overlay product__media-nav-overlay--prev'
    prev.setAttribute('aria-label', 'Previous image')

    const next = document.createElement('button')
    next.type = 'button'
    next.className = 'product__media-nav-overlay product__media-nav-overlay--next'
    next.setAttribute('aria-label', 'Next image')

    function getSwiper() {
      return sliderEl.swiper || (sliderEl.parentElement && sliderEl.parentElement.swiper) || null
    }

    prev.addEventListener('click', function (e) {
      e.preventDefault()
      const sw = getSwiper()
      if (sw && typeof sw.slidePrev === 'function') sw.slidePrev()
    })
    next.addEventListener('click', function (e) {
      e.preventDefault()
      const sw = getSwiper()
      if (sw && typeof sw.slideNext === 'function') sw.slideNext()
    })

    sliderEl.appendChild(prev)
    sliderEl.appendChild(next)
  }

  function init() {
    if (isTouch()) return
    document
      .querySelectorAll('.product__media-list.js-media-list.swiper')
      .forEach(attachToSlider)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  // Re-attach if the section is reloaded via theme-editor.
  document.addEventListener('shopify:section:load', init)

  // Swiper inits asynchronously. Retry a few times to make sure the instance
  // exists when we try to call slidePrev/slideNext on the first click.
  // The overlays are added immediately so the cursor change works; we just
  // re-query .swiper at click time.
})()
